import AbstractCommand from "../../../../../../shared/src/ranj/app/core/AbstractCommand";
import GameModel from "../model/GameModel";
import GameFlowEvent from "./GameFlowEvent";


export default class StartGameCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, gameModel) {
        super(dispatcher);

        this.execute = function (event) {
            // NB: the introduction/tutorial screen has been deprecated for this game
            this.dispatch(GameFlowEvent.INTRO_COMPLETED);
        };
    }

}